module.exports = __webpack_public_path__ + "img/classic_unknown.9df57872.png";